export const removeEmptySpaces = data => {
  const regex = /<[^>]+>/g;
  if (typeof data === "object") {
    for (let key in data) {
      data[key] = data[key].trim();
    }
    return data;
  } else if (typeof data === "string") {
    data = data.replace(regex, "").trim();
    return data;
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/components/Utils/removeEmptySpaces.js